export default {
  section_title: 'Steuerbehandlung',
  inherited_from_partner: 'Übernommen',
  inherited_from_region: 'Regionaler Standard',
  reset: 'Auf übernommenen Wert zurücksetzen',
  form: {
    tax_name: {
      label: 'Steuerbezeichnung',
      tooltip: 'Wie die Steuer auf Belegen und Rechnungen genannt wird, zum Beispiel MwSt.',
    },
    tax_behaviour: {
      label: 'Steuerbehandlung',
      tooltip: 'Ob Ihre Menüpreise die Steuer bereits enthalten oder die Steuer beim Bezahlen aufgeschlagen wird.',
      options: {
        inclusive: 'In den Menüpreisen enthalten',
        exclusive: 'Beim Bezahlen aufgeschlagen',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Steuersatz für Lieferkosten',
      tooltip: 'Der Steuersatz für Ihre eigenen Lieferkosten, der vom Satz auf die Speisen abweichen kann.',
    },
  },
  impact: {
    title: 'Steuerbehandlung für Ihre Restaurants ändern?',
    affected_one: '{{count}} Restaurant übernimmt Ihren Standardwert und wird geändert.',
    affected_other: '{{count}} Restaurants übernehmen Ihren Standardwert und werden geändert.',
    overriding_one: '{{count}} Restaurant hat eine eigene Einstellung und behält sie.',
    overriding_other: '{{count}} Restaurants haben eine eigene Einstellung und behalten sie.',
    confirm: 'Ändern',
  },
  buttons: {
    save: 'Speichern',
    cancel: 'Abbrechen',
  },
  toasts: {
    load_error: 'Steuereinstellungen konnten nicht geladen werden',
    impact_error: 'Es konnte nicht geprüft werden, welche Restaurants dies ändern würde',
    impact_changed_one:
      'Die Anzahl der betroffenen Restaurants hat sich auf {{count}} geändert. Bitte prüfen und erneut speichern.',
    impact_changed_other:
      'Die Anzahl der betroffenen Restaurants hat sich auf {{count}} geändert. Bitte prüfen und erneut speichern.',
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    changes_got_saved: 'Änderungen wurden gespeichert',
  },
};
